<template>
	<div class="shopLibrary">
		<div class="search mb-24">
			<search @onSubmit="onSubmit" @clear="onClear" :platformId="platformId" :sourceType="'waste'"></search>
		</div>
		<div class="multi-table">
			<platform-tab @change="handleClick" :platformId="platformId"></platform-tab>
			<multi-table
				ref="multiTable"
				:selectable="selectable"
				:selectionChange="selectionChange"
				:columns="columns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
			>
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</div>
		<del-dialog ref="delDialog" @delSuccess="getShopList"></del-dialog>
		<!--标签更改dialog-->
		<tagDialog ref="tagDialog" @refreshList="getShopList"></tagDialog>
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import getColums from './columns';
import search from './components/search.vue';
import { wasteList } from '@/api/shopManage';
import { menuType } from '@/utils/dataMap';
import delDialog from '@/views/common/dialog/delete.vue';
import PlatformTab from '@/components/platformTab';
import empty from '@/views/common/empty/index.vue';
import debounce from 'lodash/debounce';
import TagDialog from '@/components/business/tagDialog';
export default {
	name: 'shopLibrary',
	components: {
		search,
		delDialog,
		PlatformTab,
		empty,
		TagDialog,
	},
	data() {
		return {
			list: [],
			options: {
				selectable: true,
				border: false,
			},
			pageInfo: {
				page_index: 1,
				page_size: 10,
				item_total: 0,
			},
			total: '0',
			selectionShopArr: [],
			params: {
				page_index: 1,
				page_size: 10,
			},
			filterArr: [],
			isSearch: false,
			platformId: '',
		};
	},
	computed: {
		...mapGetters(['defaultPlatform', 'isDrPartnerDataView']),
		...mapState(['vuex_userInfo']),
		columns() {
			const col = getColums(this).filter(val => {
				if (val.key == 'operations') {
					val.key = 'operation';
				}
				return val.isShow;
			});
			return col;
		},
	},
	created() {
		this.platformId = +this.defaultPlatform;
		this.getShopList();
	},
	methods: {
		handleClick(val) {
			this.platformId = val;
			this.params = {
				page_index: 1,
				page_size: 10,
			};
			this.getShopList();
		},
		//商品列表
		getShopList: debounce(async function (isSearch) {
			this.isSearch = Boolean(isSearch);
			this.params.platform_id = this.platformId;
			const {
				code,
				data: { list = [], page = {} },
			} = await wasteList(this.params);
			if (code === 0) {
				this.list = list.map(item => ({
					...item,
					operations: { tagDialog: this.handleEditTag },
					operation: this.getButtons(item),
				}));
				this.total = `${page.item_total}`;
			}
		}, 300),
		//操作按钮
		getButtons(item) {
			let arr = [];
			if (this.$auth.hasPermi('system:waster:recover')) {
				arr.push({
					label: '恢复',
					type: 'text',
					classtype: 2,
					notSelf: !item.is_self,
					tagDialog: this.handleEditTag,
					click: row => {
						if (item.is_self) {
							this.$refs.delDialog.delInit(row, menuType.waste, '是否确认恢复商品？');
						}
					},
				});
			}
			return arr;
		},
		handleEditTag(row) {
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
		//是否勾选
		selectable({ other_status }) {
			return ![2, 3].includes(other_status);
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs.multiTable.resetPage();
			this.getShopList(1);
		},
		onClear(val) {
			this.onSubmit(val);
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getShopList();
		},
	},
};
</script>
<style lang="less" scoped>
// 颜色 #E559EF
</style>
